import { formatDate } from '@root/helpers';
import type { CellContext, ColumnHelper } from '@tanstack/react-table';

export const effectiveToAccessor = <T extends { expiry_date?: string }>(columnHelper: ColumnHelper<T>) =>
  columnHelper.accessor((row) => row.expiry_date, {
    id: 'expiry_date',
    header: 'Effective to',
    enableColumnFilter: false,
    size: 128,
    minSize: 128,
    maxSize: 128,
    cell: (cellContext: CellContext<T, string>) =>
      formatDate(cellContext.row.original.expiry_date ?? '', 'DD MMM YYYY'),
    sortingFn: 'datetime',
    sortUndefined: -1,
    meta: {
      headingCellClassName: 'w-32',
    },
  });
